import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { userDetails } from '../../../state/ducks/users/users';
import { RootState } from '../../../state/store/store';
import Button from '../../shared/SmallComponents/Button';
import { Option } from '../../shared/SmallComponents/DropDown';
import FieldLabel from '../../shared/SmallComponents/FieldLabel';
import { UserDropDown } from '../../shared/inputs/base';
import { FormDatePicker, FormDropDown, FormTextInput } from '../../shared/inputs/form';
import { IFollowUpExtended } from './FollowUp';
import followUpselectors from '../../../state/ducks/followUps/selectors';
export type shipmentFilterField = { field: keyof IFollowUpExtended | string; value: any };
export type filterFieldsType = Array<shipmentFilterField>;
export interface FollowUpFilterData {
    shipperOptions: Array<Option>;
    consigneeOptions: Array<Option>;
    cargoOwnerOptions: Array<Option>;
    containerNumberOptions: Array<Option>;
    awbOptions: Array<Option>;
    stateOptions: Array<Option>;
}
type Props = {
    onCancel: () => void;
    setShipmentFilters: (filter: filterFieldsType, disableDefaultActiveFilter?: boolean) => void;
    filterData: FollowUpFilterData;
};

type formFilterFields = {
    assignee?: string;
    shipmentNumber?: string;
    currentState?: string[];
    previousState?: string[];
    shipper?: string[];
    consignee?: string[];
    cargoOwner?: string[];
    containerNumber?: string[];
    awb?: string[];
    trackingId?: string;
    fromDueDate?: Date;
    toDueDate?: Date;
    customsFile?: string;
};

const FilterContent = ({ onCancel, setShipmentFilters, filterData }: Props) => {
    const [formFieldsValues, setFormFieldsValues] = useState<formFilterFields>({});
    // useEffect(() => {
    //     const filterFieldsValues: formFilterFields = {};
    //     filterFields?.forEach(({ field, value }: { field: string; value: any }) => {
    //         (filterFieldsValues as any)[field] = value;
    //     });
    //     setFormFieldsValues(filterFieldsValues);
    // }, [filterFields]);
    const setInitialValues = () => {
        return formFieldsValues;
    };
    const validate = (values: any) => {
        const errors: any = {};
        return errors;
    };
    const submit = (values: any) => {
        const filter: filterFieldsType = [];
        Object.keys(formFieldsValues).forEach((item) => {
            if (item !== 'calcDate' && (formFieldsValues as any)[item] && (formFieldsValues as any)[item].length !== 0)
                filter.push({ field: item, value: (formFieldsValues as any)[item] });
        });
        setShipmentFilters(filter, true);
        onCancel();
    };
    const resetForm = () => {
        setFormFieldsValues({});
        setShipmentFilters([], false);
    };
    const [users] = useState<Array<userDetails>>();

    return (
        <Formik initialValues={setInitialValues()} validate={validate} onSubmit={submit}>
            {({ values, setFieldValue }: any) => {
                return (
                    <FormContainer>
                        <Container>
                            <FieldContainer data-popover-bug>
                                <FieldLabel>Current State</FieldLabel>
                                <FormDropDown
                                    preventPopoverBug={true}
                                    name="currentState"
                                    placeHolder="Current State"
                                    options={filterData.stateOptions}
                                    allowClear
                                    mode="multiple"
                                    onChange={(value: string[]) => setFormFieldsValues({ ...formFieldsValues, currentState: value })}
                                    value={formFieldsValues.currentState}
                                />
                            </FieldContainer>
                            <FieldContainer data-popover-bug>
                                <FieldLabel>Previous State</FieldLabel>
                                <FormDropDown
                                    preventPopoverBug={true}
                                    name="previousState"
                                    placeHolder="Previous State"
                                    options={filterData.stateOptions}
                                    allowClear
                                    mode="multiple"
                                    onChange={(value: string[]) => setFormFieldsValues({ ...formFieldsValues, previousState: value })}
                                    value={formFieldsValues.previousState}
                                />
                            </FieldContainer>
                            <Divider />
                            <FieldContainer data-popover-bug>
                                <FieldLabel>Shipper</FieldLabel>
                                <FormDropDown
                                    preventPopoverBug={true}
                                    name="shipper"
                                    placeHolder="Shipper"
                                    options={filterData.shipperOptions}
                                    allowClear
                                    mode="multiple"
                                    onChange={(value: string[]) => setFormFieldsValues({ ...formFieldsValues, shipper: value })}
                                    value={formFieldsValues.shipper}
                                />
                            </FieldContainer>
                            <FieldContainer data-popover-bug>
                                <FieldLabel>Consignee</FieldLabel>
                                <FormDropDown
                                    preventPopoverBug={true}
                                    name="consignee"
                                    placeHolder="Consignee"
                                    options={filterData.consigneeOptions}
                                    allowClear
                                    mode="multiple"
                                    onChange={(value: string[]) => setFormFieldsValues({ ...formFieldsValues, consignee: value })}
                                    value={formFieldsValues.consignee}
                                />
                            </FieldContainer>
                            <Divider />
                            <FieldContainer data-popover-bug>
                                <FieldLabel>Cargo Owner</FieldLabel>
                                <FormDropDown
                                    preventPopoverBug={true}
                                    name="cargoOwner"
                                    placeHolder="Cargo Owner"
                                    options={filterData.cargoOwnerOptions}
                                    allowClear
                                    mode="multiple"
                                    onChange={(value: string[]) => setFormFieldsValues({ ...formFieldsValues, cargoOwner: value })}
                                    value={formFieldsValues.cargoOwner}
                                />
                            </FieldContainer>
                            <FieldContainer data-popover-bug>
                                <FieldLabel>Container Number</FieldLabel>
                                <FormDropDown
                                    preventPopoverBug={true}
                                    name="containerNumber"
                                    placeHolder="Container Number"
                                    options={filterData.containerNumberOptions}
                                    allowClear
                                    mode="multiple"
                                    onChange={(value: string[]) => setFormFieldsValues({ ...formFieldsValues, containerNumber: value })}
                                    value={formFieldsValues.containerNumber}
                                />
                            </FieldContainer>
                            <FieldContainer data-popover-bug>
                                <FieldLabel>AWB</FieldLabel>
                                <FormDropDown
                                    preventPopoverBug={true}
                                    name="awb"
                                    placeHolder="AWB"
                                    options={filterData.awbOptions}
                                    allowClear
                                    mode="multiple"
                                    onChange={(value: string[]) => setFormFieldsValues({ ...formFieldsValues, awb: value })}
                                    value={formFieldsValues.awb}
                                />
                            </FieldContainer>
                            <FieldContainer>
                                <FieldLabel>Assignee</FieldLabel>
                                <UserDropDown
                                    value={formFieldsValues.assignee}
                                    users={users}
                                    placeHolder="Salesman"
                                    mode="multiple"
                                    showSearch
                                    customUsers
                                    onChange={(value: string) => setFormFieldsValues({ ...formFieldsValues, assignee: value })}
                                />
                            </FieldContainer>
                            <Divider />
                            <FieldContainer data-popover-bug>
                                <FieldLabel>From Due Date</FieldLabel>
                                <FormDatePicker
                                    name="fromDueDate"
                                    placeHolder="From Due Date"
                                    onChange={(value: Date) => setFormFieldsValues({ ...formFieldsValues, fromDueDate: value })}
                                    value={formFieldsValues.fromDueDate}
                                    preventPopoverBug={true}
                                />
                            </FieldContainer>
                            <FieldContainer data-popover-bug>
                                <FieldLabel>To Due Date</FieldLabel>
                                <FormDatePicker
                                    name="toDueDate"
                                    placeHolder="To Due Date"
                                    onChange={(value: Date) => setFormFieldsValues({ ...formFieldsValues, toDueDate: value })}
                                    value={formFieldsValues.toDueDate}
                                    preventPopoverBug={true}
                                />
                            </FieldContainer>
                            <Divider />
                            <FieldContainer>
                                <FieldLabel>Tracking Id</FieldLabel>
                                <FormTextInput
                                    name="trackingId"
                                    placeHolder="Tracking Id"
                                    onChange={(value: string) => setFormFieldsValues({ ...formFieldsValues, trackingId: value })}
                                    value={formFieldsValues.trackingId}
                                    allowClear
                                />
                            </FieldContainer>
                            <FieldContainer>
                                <FieldLabel>Customs File</FieldLabel>
                                <FormTextInput
                                    name="customsFile"
                                    placeHolder="Customs File"
                                    onChange={(value: string) => setFormFieldsValues({ ...formFieldsValues, customsFile: value })}
                                    value={formFieldsValues.customsFile}
                                    allowClear
                                />
                            </FieldContainer>
                        </Container>
                        <FormFooter>
                            <Button minWidth="55px" type="button" onClick={onCancel}>
                                <span>Cancel</span>
                            </Button>
                            <Flex>
                                <Button minWidth="55px" type="button" onClick={resetForm}>
                                    <span>Reset</span>
                                </Button>
                                <Button minWidth="55px" buttonType="filled" type="submit">
                                    <span>Filter</span>
                                </Button>
                            </Flex>
                        </FormFooter>
                    </FormContainer>
                );
            }}
        </Formik>
    );
};
const FormContainer = styled(Form)`
    min-width: 500px;
    @media screen and (max-width: 768px) {
        min-width: 100%;
    }
`;
const FieldContainer = styled.div`
    margin-bottom: 12px;
    flex-basis: 45%;
    width: 0;
    padding: 0 10px;
    @media screen and (max-width: 768px) {
        flex-basis: 100%;
    }
`;
const Divider = styled.div`
    width: 100%;
    margin-bottom: 12px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    @media screen and (max-width: 768px) {
        display: none;
    }
`;
const Container = styled.div`
    width: 100%;
    max-height: 420px;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
        height: calc(100vh - 70px);
        padding: 4px 12px;
        max-height: 100%;
    }
`;
const FormFooter = styled.div`
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 70px;
    padding: 17px 30px;
    border-top: 1px solid #eaeaea;
    left: 0;
    right: 0;
    bottom: -70px;
    background: white;
    box-shadow: 0 9px 12px 1px rgb(0 0 0 / 9%);
    button {
        padding: 15px;
    }
    @media screen and (max-width: 768px) {
        bottom: 0;
        button {
            span {
                display: -webkit-box;
            }
        }
    }
`;
const Flex = styled.div`
    display: flex;
`;
const mapStateToProps = (state: RootState) => ({
    filterData: followUpselectors.getFilterData(state),
    filterFields: followUpselectors.filterFields(state)
    // businessPartnerForwarders: businessPartnersSelectors.businessPartnerForwarders(state),
    // allowedCompanies: userSelectors.allowedCompanies(state),
    // shipmentStateOptions: shipmentsSelectors.shipmentStateOptions(state)
});
const mapDispatchToProps = (dispatch: any) => ({
    setShipmentFilters: (filter: filterFieldsType) => dispatch.followUps.setFilterFields(filter)
});
export default connect(mapStateToProps, mapDispatchToProps)(FilterContent);
